export const VUEX_TOAST_SHOW = 'VUEX_TOAST_SHOW'
export const VUEX_TOAST_HIDE = 'VUEX_TOAST_HIDE'

export const VUEX_TOAST_SET_STATE = 'VUEX_TOAST_SET_STATE'
export const VUEX_TOAST_ADD_TO_QUEUE = 'VUEX_TOAST_ADD_TO_QUEUE'
export const VUEX_TOAST_CLEAR = 'VUEX_TOAST_CLEAR'
export const VUEX_TOAST_PROCCESS = 'VUEX_TOAST_PROCCESS'
export const VUEX_TOAST_CYCLE_COMPLETE = 'VUEX_TOAST_CYCLE_COMPLETE'
